/*
  RevoRope — filtrado client-side de la colección de Accesorios por categoría (tags).
  Los chips (Todos / Soportes / Anclajes) enseñan u ocultan tarjetas según el tag del
  producto, sin recargar. Lee ?filtro=<tag> de la URL para el enlace directo del
  mega-menú y refleja el filtro activo en la URL con replaceState. Chips accesibles
  (button real + aria-pressed). Si no hay barra de filtros (p. ej. Máquinas), no hace
  nada. No depende de los filtros nativos de Shopify (Search & Discovery).
*/
(function () {
  'use strict';

  var bar = document.querySelector('[data-rr-filtro-bar]');
  var grid = document.querySelector('[data-rr-grid]');
  if (!bar || !grid) return;

  var chips = Array.prototype.slice.call(bar.querySelectorAll('[data-rr-filtro]'));
  var cells = Array.prototype.slice.call(grid.querySelectorAll('.rr-coleccion__cell'));
  var count = document.querySelector('[data-rr-count]');
  var noresults = document.querySelector('[data-rr-noresults]');
  if (!chips.length || !cells.length) return;

  function aplicar(tag) {
    var visibles = 0;
    cells.forEach(function (cell) {
      var tags = (cell.getAttribute('data-rr-tags') || '').split(',');
      var mostrar = !tag || tags.indexOf(tag) !== -1;
      cell.classList.toggle('is-hidden', !mostrar);
      if (mostrar) visibles += 1;
    });

    chips.forEach(function (chip) {
      var activo = (chip.getAttribute('data-rr-filtro') || '') === tag;
      chip.classList.toggle('is-active', activo);
      chip.setAttribute('aria-pressed', activo ? 'true' : 'false');
    });

    if (count) {
      count.textContent = visibles + ' ' + (visibles === 1 ? 'producto' : 'productos');
    }
    if (noresults) {
      noresults.hidden = visibles !== 0;
    }
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var tag = chip.getAttribute('data-rr-filtro') || '';
      aplicar(tag);
      try {
        var url = new URL(window.location.href);
        if (tag) {
          url.searchParams.set('filtro', tag);
        } else {
          url.searchParams.delete('filtro');
        }
        window.history.replaceState(null, '', url);
      } catch (e) { /* URL no soportada: ignorar */ }
    });
  });

  // Enlace directo: aplicar el filtro pedido en la URL si existe un chip para él.
  var inicial = '';
  try {
    inicial = new URL(window.location.href).searchParams.get('filtro') || '';
  } catch (e) { inicial = ''; }
  var existe = chips.some(function (c) {
    return (c.getAttribute('data-rr-filtro') || '') === inicial;
  });
  aplicar(existe ? inicial : '');
})();
